module.exports = __webpack_public_path__ + "static/media/hero_brighton_getty.6d48b6ab.jpg";